import { render, staticRenderFns } from "./CustomCategoriesTreeView.vue?vue&type=template&id=16d617d2"
import script from "./CustomCategoriesTreeView.vue?vue&type=script&lang=js"
export * from "./CustomCategoriesTreeView.vue?vue&type=script&lang=js"
import style0 from "./CustomCategoriesTreeView.vue?vue&type=style&index=0&id=16d617d2&prod&lang=scss"
import style1 from "./CustomCategoriesTreeView.vue?vue&type=style&index=1&id=16d617d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VChip,VCol,VIcon,VMenu,VRow,VSwitch,VTextField,VTreeview})
